var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoUserCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8097 10.6124C10.7172 9.21741 7.30473 9.21741 5.19723 10.6124C4.24473 11.2499 3.71973 12.1124 3.71973 13.0349C3.71973 13.9574 4.24473 14.8124 5.18973 15.4424C6.23973 16.1474 7.61973 16.4999 8.99973 16.4999C10.3797 16.4999 11.7597 16.1474 12.8097 15.4424C13.7547 14.8049 14.2797 13.9499 14.2797 13.0199C14.2722 12.0974 13.7547 11.2424 12.8097 10.6124Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoUserCount);
export default __webpack_public_path__ + "static/media/trvto_userCount.e8ec7e64f16b2eeed88ef57ca5827b33.svg";
export { ForwardRef as ReactComponent };